import { useState } from "react";
import { useNavigate } from "react-router-dom";
import YildizArkaplan from "../components/YildizArkaplan";
import { useTranslation } from "react-i18next";

const HAYAT_YOLU_ANLAMLARI = {
  1: { baslik: "Lider & Öncü", sembol: "☀️", renk: "#F9CB42", aciklama: "Sen doğuştan bir lidersin. Bağımsız, kararlı ve yaratıcısın. Kendi yolunu çizmekten korkmazsın. Hayatın boyunca öncülük etmek, yeni şeyler başlatmak ve başkalarına ilham vermek sana verilmiş bir hediyedir.", gucluyonler: ["Liderlik", "Yaratıcılık", "Bağımsızlık", "Kararlılık"], dikkat: "Bazen çok ısrarcı veya bencil görünebilirsin. Başkalarının fikirlerine de alan tanı." },
  2: { baslik: "Arabulucu & Denge", sembol: "🌙", renk: "#A855F7", aciklama: "Sen ilişkilerin ustasısın. Empati, işbirliği ve denge senin doğanın bir parçası. İnsanları bir araya getirme ve uyum yaratma konusunda eşsiz bir yeteneğin var.", gucluyonler: ["Empati", "Diplomasi", "Sabır", "İşbirliği"], dikkat: "Kendi ihtiyaçlarını sürekli ikinci plana atabilirsin. Kendine de zaman ayır." },
  3: { baslik: "Yaratıcı & İfadeci", sembol: "✨", renk: "#F472B6", aciklama: "Yaratıcılık ve ifade senin can suyun. Sanat, müzik, yazı veya konuşmayla kendini ifade etmek sana derin bir tatmin verir.", gucluyonler: ["Yaratıcılık", "İletişim", "Neşe", "İlham"], dikkat: "Odaklanmakta güçlük çekebilirsin. Enerjini bir yere yönlendirmeyi öğren." },
  4: { baslik: "Kurucu & Düzenleyici", sembol: "🏛️", renk: "#34D399", aciklama: "Sen güvenilirliğin ve disiplinin simgesisin. Sağlam temeller üzerine kurulu bir hayat inşa etmek senin doğandadır.", gucluyonler: ["Disiplin", "Güvenilirlik", "Pratiklik", "Kararlılık"], dikkat: "Bazen çok katı veya değişime kapalı olabilirsin. Esnekliği de kucakla." },
  5: { baslik: "Özgürlük & Macera", sembol: "🌊", renk: "#38BDF8", aciklama: "Özgürlük senin en büyük değerin. Değişim, macera ve yeni deneyimler seni besler.", gucluyonler: ["Uyum sağlama", "Merak", "Özgürlük", "Karizmatik"], dikkat: "İstikrarsızlık ve sorumluluktan kaçma eğilimin olabilir. Köklere ihtiyacın da var." },
  6: { baslik: "Şefkat & Sorumluluk", sembol: "💜", renk: "#C084FC", aciklama: "Sen doğuştan bir bakıcısın. Aile, ev ve sevdiklerine duyduğun derin bağlılık hayatının merkezinde.", gucluyonler: ["Şefkat", "Sadakat", "Sorumluluk", "Koruyuculuk"], dikkat: "Başkalarına o kadar çok odaklanırsın ki kendini ihmal edebilirsin. Sınırlar koy." },
  7: { baslik: "Bilge & Araştırmacı", sembol: "🔮", renk: "#818CF8", aciklama: "Sen derinliğin ve bilgeliğin insanısın. İçsel yolculuk, mistik bilgi ve evrenin sırlarını keşfetmek seni büyüler.", gucluyonler: ["Analiz", "Sezgi", "Bilgelik", "Derinlik"], dikkat: "İçine kapanık ve yalnız kalma eğilimin olabilir. Bağlantı kurmayı ihmal etme." },
  8: { baslik: "Güç & Başarı", sembol: "👑", renk: "#F9CB42", aciklama: "Sen başarı ve gücün insanısın. Maddi dünyada büyük şeyler başarma potansiyeline sahipsin.", gucluyonler: ["Hırs", "Liderlik", "Strateji", "Güç"], dikkat: "Para ve güce aşırı odaklanmak manevi tarafını ihmal ettirebilir. Denge önemli." },
  9: { baslik: "İnsancıl & Evrensel", sembol: "🌍", renk: "#F472B6", aciklama: "Sen insanlığa hizmet etmek için doğmuşsun. Evrensel sevgi, şefkat ve idealizm senin rehber yıldızlarındır.", gucluyonler: ["Evrensel sevgi", "İdealizm", "Bağışlama", "Vizyoner"], dikkat: "Hayal kırıklığına uğramaya açıksın. İnsanların sınırlarını kabullenmek zor gelebilir." },
  11: { baslik: "Usta Sayı — Sezgisel Lider", sembol: "⚡", renk: "#38BDF8", aciklama: "11, usta sayılardan biri. Olağanüstü sezgi, ruhsal farkındalık ve ilham verme gücüne sahipsin.", gucluyonler: ["Sezgi", "İlham", "Ruhsallık", "Vizyon"], dikkat: "Bu yoğun enerji kaygı ve hassasiyete yol açabilir. Kendinle nazik ol." },
  22: { baslik: "Usta Sayı — Büyük Kurucu", sembol: "🏗️", renk: "#34D399", aciklama: "22, en güçlü usta sayıdır. Dünyayı değiştirecek büyük projeler hayata geçirme potansiyeline sahipsin.", gucluyonler: ["Vizyon", "Pratiklik", "Kararlılık", "Liderlik"], dikkat: "Üstlendiğin yük çok ağır gelebilir. Yardım istemeyi öğren." },
  33: { baslik: "Usta Sayı — Usta Öğretmen", sembol: "🕊️", renk: "#F472B6", aciklama: "33, şefkat ve öğretmenliğin en yüce ifadesidir. İnsanları iyileştirme, ilham verme ve sevgiyle kucaklama enerjisiyle doludur.", gucluyonler: ["Şefkat", "Öğretmenlik", "İyileştirme", "Sevgi"], dikkat: "Kendin için yaşamayı unutabilirsin. Kendi ruhsal yolculuğunu da ihmal etme." },
};

function hayatYoluHesapla(tarih) {
  if (!tarih) return null;
  const [yil, ay, gun] = tarih.split("-").map(Number);
  const topla = (sayi) => {
    let s = sayi;
    while (s > 9 && s !== 11 && s !== 22 && s !== 33) {
      s = String(s).split("").reduce((a, b) => a + parseInt(b), 0);
    }
    return s;
  };
  const gunT = topla(gun);
  const ayT = topla(ay);
  const yilT = topla(yil);
  return topla(gunT + ayT + yilT);
}

export default function Numeroloji() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [dogumTarihi, setDogumTarihi] = useState("");
  const [sonuc, setSonuc] = useState(null);

  const hesapla = () => {
    if (!dogumTarihi) return;
    setSonuc(hayatYoluHesapla(dogumTarihi));
  };

  const anlam = sonuc ? HAYAT_YOLU_ANLAMLARI[sonuc] : null;

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(180deg, #0a0718 0%, #110d24 40%, #0d0a1a 100%)",
      position: "relative", fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
      maxWidth: 420, margin: "0 auto",
    }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { display: none; }
        @keyframes kart-gir { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        input:focus { outline: none; }
      `}</style>

      <YildizArkaplan />

      <div style={{ position: "relative", zIndex: 1, paddingBottom: 100 }}>

        {/* Geri */}
        <div style={{ padding: "52px 24px 0" }}>
          <button onClick={() => navigate(-1)} style={{
            background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.12)",
            borderRadius: 12, padding: "8px 16px", color: "rgba(255,255,255,0.7)", fontSize: 13, cursor: "pointer",
          }}>{t("numerology.back")}</button>
        </div>

        {/* Başlık */}
        <div style={{ padding: "24px 24px 0", textAlign: "center" }}>
          <div style={{ fontSize: 56, marginBottom: 12 }}>🔢</div>
          <div style={{ fontSize: 26, fontWeight: 800, color: "#fff", fontFamily: "Georgia, serif", marginBottom: 8 }}>
            {t("numerology.title")}
          </div>
          <div style={{ fontSize: 13, color: "rgba(200,170,255,0.7)", marginBottom: 4 }}>
            {t("numerology.subtitle")}
          </div>
        </div>

        {/* Numeroloji Nedir */}
        <div style={{ padding: "24px 24px 0" }}>
          <div style={{
            background: "rgba(255,255,255,0.03)", border: "1px solid rgba(168,85,247,0.2)",
            borderRadius: 18, padding: "20px",
          }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#C084FC", marginBottom: 10, fontFamily: "Georgia, serif" }}>
              {t("numerology.whatIs")}
            </div>
            <div style={{ fontSize: 13, color: "rgba(255,255,255,0.65)", lineHeight: 1.8, whiteSpace: "pre-line" }}>
              {t("numerology.whatIsDesc")}
            </div>
          </div>
        </div>

        {/* Nasıl Hesaplanır */}
        <div style={{ padding: "16px 24px 0" }}>
          <div style={{
            background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: 18, padding: "20px",
          }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#F9CB42", marginBottom: 12, fontFamily: "Georgia, serif" }}>
              {t("numerology.howCalc")}
            </div>
            <div style={{ fontSize: 13, color: "rgba(255,255,255,0.65)", lineHeight: 1.8, marginBottom: 14 }}>
              {t("numerology.howCalcDesc")}
            </div>
            <div style={{
              background: "rgba(249,203,66,0.08)", border: "1px solid rgba(249,203,66,0.2)",
              borderRadius: 12, padding: "14px",
            }}>
              <div style={{ fontSize: 12, color: "rgba(249,203,66,0.7)", marginBottom: 8, fontWeight: 600 }}>
                {t("numerology.exampleLabel")}
              </div>
              <div style={{ fontSize: 12, color: "rgba(255,255,255,0.6)", lineHeight: 2 }}>
                {`Gün: 1+5 = 6\nAy: 3\nYıl: 1+9+9+0 = 19 → 1+9 = 10 → 1+0 = 1\nToplam: 6+3+1 = 10 → 1+0 = 1`}
              </div>
            </div>
          </div>
        </div>

        {/* Kullanım Alanları */}
        <div style={{ padding: "16px 24px 0" }}>
          <div style={{
            background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: 18, padding: "20px",
          }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#34D399", marginBottom: 12, fontFamily: "Georgia, serif" }}>
              {t("numerology.usageTitle")}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {[
                { icon: "💖", key: "love" },
                { icon: "💼", key: "career" },
                { icon: "🍀", key: "luck" },
                { icon: "🧠", key: "personality" },
              ].map((item) => (
                <div key={item.key} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={{
                    width: 36, height: 36, borderRadius: 10,
                    background: "rgba(52,211,153,0.1)", border: "1px solid rgba(52,211,153,0.2)",
                    display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0,
                  }}>{item.icon}</div>
                  <div>
                    <div style={{ fontSize: 13, color: "#fff", fontWeight: 600 }}>{t(`numerology.usages.${item.key}.title`)}</div>
                    <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)" }}>{t(`numerology.usages.${item.key}.desc`)}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Hesaplayıcı */}
        <div style={{ padding: "16px 24px 0" }}>
          <div style={{
            background: "linear-gradient(135deg, rgba(107,63,160,0.3), rgba(168,85,247,0.15))",
            border: "1px solid rgba(168,85,247,0.3)", borderRadius: 18, padding: "20px",
          }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#C084FC", marginBottom: 6, fontFamily: "Georgia, serif" }}>
              {t("numerology.calcTitle")}
            </div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", marginBottom: 14 }}>
              {t("numerology.calcSubtitle")}
            </div>
            <input
              type="date"
              value={dogumTarihi}
              onChange={(e) => { setDogumTarihi(e.target.value); setSonuc(null); }}
              style={{
                width: "100%", background: "rgba(255,255,255,0.08)",
                border: "1px solid rgba(168,85,247,0.3)", borderRadius: 12,
                padding: "12px 14px", color: "#fff", fontSize: 14,
                fontFamily: "'Trebuchet MS', sans-serif", colorScheme: "dark", marginBottom: 12,
              }}
            />
            <button onClick={hesapla} disabled={!dogumTarihi} style={{
              width: "100%", padding: "14px", borderRadius: 12,
              background: dogumTarihi ? "linear-gradient(135deg, #7c3aed, #a855f7)" : "rgba(255,255,255,0.06)",
              border: "none", color: dogumTarihi ? "#fff" : "rgba(255,255,255,0.3)",
              fontSize: 14, fontWeight: 700, cursor: dogumTarihi ? "pointer" : "default",
              fontFamily: "Georgia, serif",
            }}>
              {t("numerology.calcBtn")}
            </button>
          </div>
        </div>

        {/* Sonuç */}
        {sonuc && anlam && (
          <div style={{ padding: "16px 24px 0", animation: "kart-gir 0.5s ease backwards" }}>
            <div style={{
              background: "linear-gradient(135deg, rgba(0,0,0,0.3), rgba(0,0,0,0.2))",
              border: `1px solid ${anlam.renk}44`, borderRadius: 20, overflow: "hidden",
            }}>
              <div style={{
                background: `linear-gradient(135deg, ${anlam.renk}33, ${anlam.renk}11)`,
                padding: "24px", textAlign: "center", borderBottom: `1px solid ${anlam.renk}22`,
              }}>
                <div style={{ fontSize: 48, marginBottom: 8 }}>{anlam.sembol}</div>
                <div style={{ fontSize: 52, fontWeight: 900, color: anlam.renk, fontFamily: "Georgia, serif", lineHeight: 1 }}>{sonuc}</div>
                <div style={{ fontSize: 16, fontWeight: 700, color: "#fff", marginTop: 8, fontFamily: "Georgia, serif" }}>{anlam.baslik}</div>
              </div>

              <div style={{ padding: "20px" }}>
                <div style={{ fontSize: 13, color: "rgba(255,255,255,0.7)", lineHeight: 1.8, marginBottom: 16 }}>
                  {anlam.aciklama}
                </div>
                <div style={{ marginBottom: 14 }}>
                  <div style={{ fontSize: 12, color: anlam.renk, fontWeight: 700, marginBottom: 8, letterSpacing: 1 }}>
                    {t("numerology.strongPoints")}
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                    {anlam.gucluyonler.map((g, i) => (
                      <div key={i} style={{
                        background: `${anlam.renk}22`, border: `1px solid ${anlam.renk}44`,
                        borderRadius: 20, padding: "4px 12px", fontSize: 12, color: anlam.renk, fontWeight: 600,
                      }}>{g}</div>
                    ))}
                  </div>
                </div>
                <div style={{
                  background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)",
                  borderRadius: 12, padding: "12px 14px",
                }}>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", marginBottom: 4, fontWeight: 600 }}>
                    {t("numerology.warning")}
                  </div>
                  <div style={{ fontSize: 12, color: "rgba(255,255,255,0.6)", lineHeight: 1.6 }}>{anlam.dikkat}</div>
                </div>
              </div>
            </div>

            <div style={{
              marginTop: 14, padding: "16px", borderRadius: 16,
              background: "rgba(168,85,247,0.08)", border: "1px solid rgba(168,85,247,0.2)", textAlign: "center",
            }}>
              <div style={{ fontSize: 13, color: "rgba(255,255,255,0.6)", marginBottom: 8 }}>
                {t("numerology.moreDetail")}
              </div>
              <div style={{ fontSize: 14, color: "#C084FC", fontWeight: 700 }}>
                {t("numerology.comingSoon")}
              </div>
              <div style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", marginTop: 4 }}>
                {t("numerology.comingSoonDesc")}
              </div>
            </div>
          </div>
        )}

        {/* Sayıların Anlamları */}
        <div style={{ padding: "20px 24px 0" }}>
          <div style={{ fontSize: 13, color: "rgba(200,170,255,0.6)", letterSpacing: 2, textTransform: "uppercase", fontWeight: 600, marginBottom: 14 }}>
            {t("numerology.numbersTitle")}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
            {[1,2,3,4,5,6,7,8,9].map(sayi => {
              const a = HAYAT_YOLU_ANLAMLARI[sayi];
              return (
                <div key={sayi} onClick={() => setSonuc(sayi)} style={{
                  background: sonuc === sayi ? `${a.renk}22` : "rgba(255,255,255,0.04)",
                  border: sonuc === sayi ? `1px solid ${a.renk}66` : `1px solid ${a.renk}22`,
                  borderRadius: 14, padding: "12px 8px", textAlign: "center", cursor: "pointer",
                }}>
                  <div style={{ fontSize: 20, marginBottom: 4 }}>{a.sembol}</div>
                  <div style={{ fontSize: 16, fontWeight: 800, color: a.renk }}>{sayi}</div>
                  <div style={{ fontSize: 9, color: "rgba(255,255,255,0.4)", marginTop: 2, lineHeight: 1.3 }}>
                    {a.baslik.split(" ")[0]}
                  </div>
                </div>
              );
            })}
          </div>

          <div style={{ marginTop: 8, display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
            {[11, 22, 33].map(sayi => {
              const a = HAYAT_YOLU_ANLAMLARI[sayi];
              return (
                <div key={sayi} onClick={() => setSonuc(sayi)} style={{
                  background: sonuc === sayi ? `${a.renk}22` : "rgba(255,255,255,0.04)",
                  border: sonuc === sayi ? `1px solid ${a.renk}66` : `1px solid ${a.renk}22`,
                  borderRadius: 14, padding: "12px 8px", textAlign: "center", cursor: "pointer",
                }}>
                  <div style={{ fontSize: 20, marginBottom: 4 }}>{a.sembol}</div>
                  <div style={{ fontSize: 14, fontWeight: 800, color: a.renk }}>{sayi}</div>
                  <div style={{ fontSize: 9, color: "rgba(255,255,255,0.4)", marginTop: 2, lineHeight: 1.3 }}>
                    {t("numerology.masterNumber")}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}